import { render, staticRenderFns } from "./solutionDetails.vue?vue&type=template&id=133ea808&"
import script from "./solutionDetails.vue?vue&type=script&lang=js&"
export * from "./solutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports